isSpecialCase